import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import th from 'date-fns/locale/th';
import { ConvertDate } from '../../pages/Function/ConvertDate';
import { Button } from 'reactstrap';
import dayjs from 'dayjs';
import { fullMonthNames } from '../../common/data/monthName';

function MyDatePicker(props) {
    const {
        setProbsDate = null,
        setDateObj = null,
        showInitialValue = false,
        className,
        maxDate = null,
        minDate = null,
        showTimePick = true,
        showCalendar = true,
        calendarClassName = "",
        icon = "fa fa-calendar",
        setForValidate = null,
        placeholderText,
        open = false,
        rounded = "rounded-0",
        initialDate = new Date(),
        wrapperClassName = "react-datepicker-wrapper",
        isDisable = false
    } = props;

    dayjs.locale("th")

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [showSelected, setShowSelected] = useState(false);

    useEffect(() => {
        setShowSelected(showInitialValue);
        setSelectedDate(showInitialValue ? new Date(new Date(initialDate).getTime() - 7 * 60 * 60 * 1000) : new Date());
    }, [])

    // dateFullFormat stores local time with Z suffix (e.g. "2026-06-26T10:30:00.000Z" means local 10:30)
    // new Date() on that string in UTC+7 returns 17:30 local, so subtract 7h to recover the correct local time
    const parseMinDate = (md) => {
        if (!md) return null;
        if (md instanceof Date) return md;
        return new Date(new Date(md).getTime() - 7 * 60 * 60 * 1000);
    };

    // filterTime compares hours/minutes in local time directly — avoids any UTC/timestamp timezone issues.
    // time = the slot Date object react-datepicker generates for the currently displayed day.
    const filterTimeByMinDate = (time) => {
        if (!minDate || !showTimePick || !showCalendar) return true;
        const minDateObj = parseMinDate(minDate);
        if (!minDateObj) return true;
        const isSameDay =
            time.getFullYear() === minDateObj.getFullYear() &&
            time.getMonth() === minDateObj.getMonth() &&
            time.getDate() === minDateObj.getDate();
        if (!isSameDay) return true;
        const timeH = time.getHours();
        const timeM = time.getMinutes();
        const minH = minDateObj.getHours();
        const minM = minDateObj.getMinutes();
        return timeH > minH || (timeH === minH && timeM >= minM);
    };

    const dateFullFormat = (e) => {
        return `${e?.getFullYear()}-${('0' + (e?.getMonth() + 1))?.slice(-2)}-${('0' + e?.getDate())?.slice(-2)}T${('0' + e?.getHours())?.slice(-2)}:${('0' + e?.getMinutes())?.slice(-2)}:00.000Z`
    }

    const dateShowFullFormat = (dateConvert) => {
        return `${('0' + dateConvert?.getDate())?.slice(-2)} ${fullMonthNames[(dateConvert?.getMonth())]} ${dateConvert?.getFullYear() + 543} ${('0' + dateConvert.getHours()).slice(-2)}:${('0' + dateConvert.getMinutes()).slice(-2)}`
    }

    const dateShow = (dateConvert) => {
        return `${('0' + dateConvert?.getDate())?.slice(-2)}/${('0' + (dateConvert?.getMonth() + 1))?.slice(-2)}/${dateConvert?.getFullYear() + 543} ${('0' + dateConvert.getHours()).slice(-2)}:${('0' + dateConvert.getMinutes()).slice(-2)}`
    }

    const setValue = (e) => {

        if (setProbsDate !== null) {
            setProbsDate(
                showTimePick && !showCalendar ?
                    ConvertDate(e).toHHmmTime
                    : showTimePick && showCalendar ? dateFullFormat(e) : ConvertDate(e).toOnlyDate
            )
        }
        if (setDateObj !== null) {
            setDateObj(
                showTimePick && !showCalendar ?
                    ConvertDate(e).toHHmmTime
                    : showTimePick && showCalendar ? dateFullFormat(e) : ConvertDate(e).toOnlyDate
            )
        }
    }

    function selectedFormat() {
        if (showTimePick === true && showCalendar === true) {
            return dateShowFullFormat(selectedDate);
        } else if (showTimePick === true && showCalendar === false) {
            return `${ConvertDate(selectedDate).toHHmmTime()}`;
        } else if (showTimePick === false && showCalendar === true) {
            return dateShow(selectedDate);
        }
    }

    return (
        <DatePicker
            disabled={isDisable}
            calendarClassName={calendarClassName}
            wrapperClassName={wrapperClassName}
            showIcon
            // showYearDropdown
            // showMonthDropdown
            // scrollableYearDropdown
            minDate={parseMinDate(minDate) || undefined}
            maxDate={maxDate || undefined}
            filterTime={filterTimeByMinDate}
            icon={icon}
            selected={selectedDate}
            showTimeSelect={showTimePick}
            showTimeSelectOnly={!showCalendar}
            onChange={(e) => {
                setSelectedDate(e);
                setShowSelected(true);
                setValue(e);
            }}
            onMonthChange={(e) => {
                setSelectedDate(e);
            }}
            onFocus={(e) => e.target.readOnly = true}
            dateFormat={selectedFormat()}
            timeCaption="เวลา"
            dateFormatCalendar={dayjs.utc(selectedDate).add(543, "year").format("D MMM YYYY")}
            locale={th}
            customInput={<Button style={{ whiteSpace: "nowrap" }} disabled={isDisable} className={`z-0 ${className || "btn-light border border-secondary-subtle px-5"} ${rounded}`}>
                {showSelected ? selectedFormat() : placeholderText ? placeholderText : showTimePick && !showCalendar ? "เลือกเวลา" : "เลือกวันที่"}
            </Button>}
        />
    );
}

export default MyDatePicker;